const BASE_FIVE = [
    'anomaly',
    'barrier',
    'ironhide',
    'riot_bot',
    'scout',
];
const RELEASE_D_ADDITIONS = [
    'arc_bolt',
    'arc_conductor',
    'assembly_robot',
    'cooling_drone',
    'defensive_circuit',
    'emergency_vent',
    'everything_machine',
    'fragment',
    'heat_sink',
    'impulse_fighter',
    'junk_barricade',
    'junk_dealer',
    'liquid_cooling',
    'microdrone',
    'overclocked_scout',
    'power_reroute',
    'reconstructed_robot',
    'recycling',
    'red_zone',
    'reinforced_microdrone',
    'riveter',
    'scatter_bolts',
    'scrap',
    'scrap_transporter',
    'sector_pulse',
    'self_copying_drone',
    'siege_resonator',
    'spare_part',
    'titan_prototype',
    'trash_critter',
    'welding_pulse',
];
const SLIME_ADDITIONS = [
    'acidic_slime',
    'blind_amoeba',
    'budding_belly',
    'colony_attack_bonus',
    'colony_devourer',
    'colony_predator',
    'contamination_map',
    'crush_and_strain',
    'deep_sample',
    'dividing_slime',
    'foreign_flesh',
    'jelly_bastion',
    'leaking_clot',
    'liquefaction',
    'mindless_slime',
    'mnemoslime',
    'overgulper',
    'pull_into_clot',
    'sample_collector',
    'single_mass',
    'slime_droplet',
    'slime_residue',
    'slimefall',
    'slippery_slime',
    'small_slime',
];
const FURNITURE_ADDITIONS = [
    'assault_stool',
    'crooked_mirror',
    'dazzling_lamp',
    'dining_table',
    'dish_sideboard',
    'drop_the_piano',
    'embroidered_cover',
    'falling_door',
    'four_legged_chair',
    'furniture_catalog',
    'grandmas_blanket',
    'iron_safe',
    'junk_chest',
    'morozko_fridge',
    'reader_armchair',
    'soft_sofa',
    'spring_cleaning',
];
const SLIME_AND_FURNITURE = [...SLIME_ADDITIONS, ...FURNITURE_ADDITIONS];
const MEDIEVAL_ADDITIONS = [
    'bandage_wounds',
    'banner_captain',
    'battle_order',
    'black_knight',
    'borderland_veteran',
    'campaign_armorer',
    'campaign_herald',
    'general_levy',
    'hunters_net',
    'mercenary_spearman',
    'militia',
    'royal_crossbowman',
    'royal_decree',
    'shield_bearer',
    'wandering_healer',
];
const PLANT_ADDITIONS = [
    'ancient_oak',
    'banyan_shoot',
    'blackthorn_sapling',
    'compost_cycle',
    'gentle_watering',
    'great_banyan',
    'great_oak_sapling',
    'growth_sunflower',
    'living_thornbush',
    'mature_blackthorn',
    'midday_sun',
    'nursery_fern',
    'overgrown_roots',
    'plant_growth',
    'plant_leaf',
    'plant_thorns',
    'rampant_bloom',
    'rootweaver_ivy',
    'thorn_seeds',
    'venus_flytrap',
];
/** D55 republishes the complete catalog under one reviewed lifecycle vocabulary. */
const D55_CATALOG_UPDATE = [
    ...BASE_FIVE,
    ...RELEASE_D_ADDITIONS,
    'data_archive',
    ...SLIME_ADDITIONS,
    ...FURNITURE_ADDITIONS,
    ...MEDIEVAL_ADDITIONS,
    ...PLANT_ADDITIONS,
];
/**
 * Public-content history. Backfill timestamps use the first-parent main commit
 * that introduced the reviewed change. New authored changes stay null until
 * the production release workflow finalizes them immediately before tagging.
 */
export const CARD_RELEASES = Object.freeze([
    {
        changeId: 'main-m6-examples',
        contentVersion: 0,
        releasedAt: '2026-07-13T10:31:16Z',
        added: BASE_FIVE,
        updated: [],
    },
    {
        changeId: 'main-release-d',
        contentVersion: 6,
        releasedAt: '2026-07-13T23:15:13Z',
        added: RELEASE_D_ADDITIONS,
        updated: BASE_FIVE,
    },
    {
        changeId: 'main-game-ui-balance',
        contentVersion: 6,
        releasedAt: '2026-07-14T11:44:55Z',
        added: [],
        updated: [
            'cooling_drone',
            'defensive_circuit',
            'emergency_vent',
            'everything_machine',
            'heat_sink',
            'red_zone',
            'riveter',
            'scatter_bolts',
            'scrap_transporter',
            'titan_prototype',
            'welding_pulse',
        ],
    },
    {
        changeId: 'main-overload-balance',
        contentVersion: 6,
        releasedAt: '2026-07-14T12:12:30Z',
        added: [],
        updated: ['emergency_vent', 'red_zone'],
    },
    {
        changeId: 'main-slime-deck',
        contentVersion: 8,
        releasedAt: '2026-07-16T07:12:39Z',
        added: SLIME_ADDITIONS,
        updated: [],
    },
    {
        changeId: 'main-furniture-deck',
        contentVersion: 8,
        releasedAt: '2026-07-16T07:43:20Z',
        added: FURNITURE_ADDITIONS,
        updated: [],
    },
    {
        changeId: 'main-card-presentation-refresh',
        contentVersion: 9,
        releasedAt: '2026-07-16T09:46:51Z',
        added: [],
        updated: SLIME_AND_FURNITURE,
    },
    {
        changeId: 'main-heavy-overload-preparation',
        contentVersion: 10,
        releasedAt: '2026-07-16T11:15:00Z',
        added: [],
        updated: ['arc_conductor', 'heat_sink', 'siege_resonator', 'titan_prototype'],
    },
    {
        changeId: 'main-data-archive-and-overload-balance',
        contentVersion: 13,
        releasedAt: '2026-07-16T15:08:36Z',
        added: ['data_archive'],
        updated: [
            'arc_conductor',
            'emergency_vent',
            'red_zone',
            'siege_resonator',
            'titan_prototype',
        ],
    },
    {
        changeId: 'main-medieval-pool',
        contentVersion: 14,
        releasedAt: '2026-07-17T14:30:59Z',
        added: MEDIEVAL_ADDITIONS,
        updated: [],
    },
    {
        changeId: 'main-player-overheal',
        contentVersion: 15,
        releasedAt: '2026-07-17T14:47:44Z',
        added: [],
        updated: ['wandering_healer'],
    },
    {
        changeId: 'main-shield-bearer-placement',
        contentVersion: 16,
        releasedAt: '2026-07-17T15:31:57Z',
        added: [],
        updated: ['shield_bearer'],
    },
    {
        changeId: 'main-plant-pool',
        contentVersion: 17,
        releasedAt: '2026-07-18T05:52:08Z',
        added: PLANT_ADDITIONS,
        updated: [],
    },
    {
        changeId: 'main-plant-tree-balance',
        contentVersion: 18,
        releasedAt: '2026-07-18T17:59:02Z',
        added: [],
        updated: [
            'ancient_oak',
            'banyan_shoot',
            'blackthorn_sapling',
            'great_banyan',
            'great_oak_sapling',
            'mature_blackthorn',
            'plant_leaf',
        ],
    },
    {
        // D55: весь каталог прошёл reviewed-миграцию на Появление/Розыгрыш/
        // Постоянно/Гибель и остальные semantic timings. Изменения поведения:
        // Лист-токен тоже лечит при Появлении; timed-Гибель запускает посмертные
        // эффекты/След и счётчик гибели токенов; Походный оружейник не тратит
        // свой эффект на себя. Тексты и mechanic-help используют единый термин «Гибель».
        changeId: 'main-appearance-timing',
        contentVersion: 20,
        releasedAt: '2026-07-20T17:30:05Z',
        added: [],
        updated: D55_CATALOG_UPDATE,
    },
    {
        // Global mechanic-help simplification plus stacking Колючки and death-based
        // Пожирание. The shared help changes republish the complete reviewed catalog.
        changeId: 'card-mechanic-help-corrections',
        contentVersion: 21,
        releasedAt: '2026-07-20T17:30:05Z',
        added: [],
        updated: D55_CATALOG_UPDATE,
    },
    {
        // Five gated rewards for the first challenge tracks. They are constructible
        // playable content, but deliberately do not occupy starter preset slots.
        changeId: 'challenge-reward-cards',
        contentVersion: 22,
        releasedAt: '2026-07-21T17:39:31Z',
        added: [
            'clockwork_ottoman',
            'royal_jelly',
            'scrap_harvester',
            'star_blossom',
            'voltaic_accumulator',
        ],
        updated: [
            'blind_amoeba',
            'colony_devourer',
            'colony_predator',
            'sample_collector',
            'single_mass',
            'slime_residue',
        ],
    },
    {
        // Challenge rewards become high-synergy archetype engines without changing
        // starter preset membership or the engine/state/protocol contracts.
        changeId: 'challenge-reward-card-engines',
        contentVersion: 23,
        releasedAt: '2026-07-21T17:39:31Z',
        added: [],
        updated: [
            'clockwork_ottoman',
            'royal_jelly',
            'scrap_harvester',
            'star_blossom',
            'voltaic_accumulator',
        ],
    },
    {
        // Remove production planning-mode dialogs from the Swarm starter. Welding
        // Pulse becomes a single Scrap transform into a 4/4 token; Recycling
        // becomes a single token sacrifice that always draws two cards.
        changeId: 'swarm-direct-targeting-simplification',
        contentVersion: 24,
        releasedAt: '2026-07-22T14:51:02Z',
        added: [],
        updated: ['recycling', 'reinforced_microdrone', 'welding_pulse'],
    },
    {
        // Reviewed multi-archetype gameplay pass: absorption grants immediate
        // readiness, and the requested Slime, Plant, medieval, Overload and
        // furniture cards receive their new deterministic behavior.
        changeId: 'multi-archetype-card-properties-pass',
        contentVersion: 25,
        releasedAt: '2026-07-22T14:51:02Z',
        added: [],
        updated: [
            'arc_conductor',
            'assault_stool',
            'blind_amoeba',
            'colony_devourer',
            'dazzling_lamp',
            'deep_sample',
            'dining_table',
            'embroidered_cover',
            'foreign_flesh',
            'grandmas_blanket',
            'hunters_net',
            'overclocked_scout',
            'overgulper',
            'pull_into_clot',
            'rampant_bloom',
            'royal_crossbowman',
            'royal_jelly',
            'single_mass',
            'slippery_slime',
            'titan_prototype',
        ],
    },
    {
        // Plant-pool rules pass: unconditional Photosynthesis, reveal/death
        // abilities, repeatable adult Growth sinks and deterministic reactive
        // Growth/Thorns interactions. Venus Flytrap also requires engine 20's
        // generic beforeOwnAttack timing; state/protocol contracts are unchanged.
        changeId: 'plant-pool-properties-pass',
        contentVersion: 26,
        releasedAt: '2026-07-22T14:51:02Z',
        added: [],
        updated: [
            'ancient_oak',
            'banyan_shoot',
            'blackthorn_sapling',
            'compost_cycle',
            'gentle_watering',
            'great_banyan',
            'great_oak_sapling',
            'growth_sunflower',
            'living_thornbush',
            'mature_blackthorn',
            'midday_sun',
            'nursery_fern',
            'overgrown_roots',
            'plant_leaf',
            'plant_thorns',
            'rootweaver_ivy',
            'star_blossom',
            'thorn_seeds',
            'venus_flytrap',
        ],
    },
    {
        // Barrier becomes a continuous source-bound aura limited to allied cards
        // in its current location; Dazzling Lamp adopts engine 22 final-position
        // retargeting for every non-cancelled positional attack group.
        changeId: 'barrier-location-aura-and-lamp-retargeting',
        contentVersion: 27,
        releasedAt: '2026-07-23T10:36:12Z',
        added: [],
        updated: ['barrier', 'dazzling_lamp'],
    },
    {
        // Anomaly now turns another card's death, while it remains on the field,
        // into a positional 2-damage strike instead of accumulating an inert
        // random counter.
        changeId: 'anomaly-death-strike',
        contentVersion: 28,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['anomaly'],
    },
    {
        // Battle Order now grants a permanent attack bonus instead of a
        // round-limited one.
        changeId: 'battle-order-permanent-buff',
        contentVersion: 28,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['battle_order'],
    },
    {
        // Blind Amoeba reacts only after its own appearance has completed, so a
        // Slime revealed earlier in the same batch is never retroactively eaten.
        changeId: 'blind-amoeba-appearance-order',
        contentVersion: 28,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['blind_amoeba'],
    },
    {
        // Campaign Armorer now also grants the next allied Unit +1 attack.
        changeId: 'campaign-armorer-attack-bonus',
        contentVersion: 28,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['campaign_armorer'],
    },
    {
        // Black Knight cannot damage a Unit that is still face down in the same
        // FIELD reveal batch.
        changeId: 'black-knight-revealed-targets',
        contentVersion: 29,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['black_knight'],
    },
    {
        // Crush and Strain can destroy any allied Slime, including a token, and
        // draws three cards after a successful destruction.
        changeId: 'crush-and-strain-token-draw',
        contentVersion: 30,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['crush_and_strain'],
    },
    {
        // Deep Sample costs two energy.
        changeId: 'deep-sample-cost-reduction',
        contentVersion: 31,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['deep_sample'],
    },
    {
        // Defensive Circuit costs two energy.
        changeId: 'defensive-circuit-cost-increase',
        contentVersion: 32,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['defensive_circuit'],
    },
    {
        // Remaining Four-Legged Chair attack parts now pass through a destroyed
        // opposing card to that side's player.
        changeId: 'four-legged-chair-overflow-damage',
        contentVersion: 33,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['four_legged_chair'],
    },
    {
        // Junk Barricade creates two Scrap tokens without scheduling their destruction.
        changeId: 'junk-barricade-persistent-scrap',
        contentVersion: 35,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['junk_barricade'],
    },
    {
        // Overgulper now absorbs any allied Slime and gains Shield 1 on appearance.
        changeId: 'overgulper-any-slime-shield-one',
        contentVersion: 36,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['overgulper'],
    },
    {
        changeId: 'riveter-no-draw-two-two',
        contentVersion: 37,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['riveter'],
    },
    {
        changeId: 'rootweaver-ivy-repeat-healing',
        contentVersion: 38,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['rootweaver_ivy'],
    },
    {
        changeId: 'royal-crossbowman-global-support',
        contentVersion: 39,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['royal_crossbowman'],
    },
    {
        changeId: 'riveter-assembly-bonuses',
        contentVersion: 40,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['riveter'],
    },
    {
        changeId: 'scrap-harvester-repeat-token-growth',
        contentVersion: 41,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['scrap_harvester'],
    },
    {
        changeId: 'sector-pulse-location-damage',
        contentVersion: 42,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['sector_pulse'],
    },
    {
        changeId: 'trash-critter-permanent-scrap-growth',
        contentVersion: 43,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['trash_critter'],
    },
    {
        changeId: 'trash-critter-lethal-scrap-growth',
        contentVersion: 44,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['trash_critter'],
    },
    {
        changeId: 'trash-critter-multi-hit-scrap-growth',
        contentVersion: 45,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['trash_critter'],
    },
    {
        changeId: 'slower-stronger-tree-maturation',
        contentVersion: 46,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: [
            'ancient_oak',
            'banyan_shoot',
            'blackthorn_sapling',
            'great_banyan',
            'great_oak_sapling',
            'mature_blackthorn',
        ],
    },
    {
        changeId: 'adult-tree-payoff-strengthening',
        contentVersion: 47,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['ancient_oak', 'great_banyan', 'mature_blackthorn'],
    },
    {
        changeId: 'adult-tree-photosynthesis',
        contentVersion: 48,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['ancient_oak', 'great_banyan', 'mature_blackthorn'],
    },
    {
        changeId: 'sunflower-intrinsic-growth-redirect',
        contentVersion: 49,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['growth_sunflower'],
    },
    {
        changeId: 'great-banyan-shield-when-full',
        contentVersion: 50,
        releasedAt: '2026-07-27T12:14:00Z',
        added: [],
        updated: ['great_banyan'],
    },
    {
        // Junk Chest draws as soon as its death resolves; Dazzling Lamp's
        // successful sidestep leaves the opposing cell empty and harmless.
        changeId: 'junk-chest-immediate-draw-and-lamp-dodge',
        contentVersion: 52,
        releasedAt: '2026-07-28T14:04:16Z',
        added: [],
        updated: ['dazzling_lamp', 'junk_chest'],
    },
    {
        changeId: 'four-legged-chair-stops-after-death',
        contentVersion: 53,
        releasedAt: '2026-07-28T14:04:16Z',
        added: [],
        updated: ['four_legged_chair'],
    },
    {
        changeId: 'star-blossom-growth-payoff-tuning',
        contentVersion: 54,
        releasedAt: '2026-07-30T18:30:43Z',
        added: [],
        updated: ['star_blossom'],
    },
    {
        changeId: 'star-blossom-growth-payoff-four-growth',
        contentVersion: 55,
        releasedAt: '2026-07-30T18:30:43Z',
        added: [],
        updated: ['star_blossom'],
    },
    {
        changeId: 'colony-predator-full-location',
        contentVersion: 56,
        releasedAt: '2026-10-05T16:59:13Z',
        added: [],
        updated: ['colony_predator'],
    },
    {
        changeId: 'heat-and-freeze-mechanics-rework',
        contentVersion: 57,
        releasedAt: '2026-10-05T16:59:13Z',
        added: ['erratic_reactor', 'meltdown_core', 'thermal_inverter'],
        updated: [
            'arc_conductor',
            'cooling_drone',
            'defensive_circuit',
            'emergency_vent',
            'heat_sink',
            'impulse_fighter',
            'liquid_cooling',
            'morozko_fridge',
            'overclocked_scout',
            'power_reroute',
            'red_zone',
            'siege_resonator',
            'titan_prototype',
            'voltaic_accumulator',
        ],
    },
    {
        changeId: 'heat-card-balance-pass',
        contentVersion: 58,
        releasedAt: '2026-10-05T16:59:13Z',
        added: [],
        updated: [
            'arc_conductor',
            'erratic_reactor',
            'impulse_fighter',
            'meltdown_core',
            'overclocked_scout',
            'thermal_inverter',
        ],
    },
]);
const UTC_TIMESTAMP = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/u;
function buildMetadataIndex(entries) {
    const result = new Map();
    const changeIds = new Set();
    const declaredAdded = new Set();
    let pendingSeen = false;
    let previousReleasedAt = '';
    for (const entry of entries) {
        if (entry.changeId.trim() === '' || changeIds.has(entry.changeId)) {
            throw new Error(`card releases: duplicate or empty changeId ${entry.changeId}`);
        }
        changeIds.add(entry.changeId);
        if (!Number.isSafeInteger(entry.contentVersion) || entry.contentVersion < 0) {
            throw new Error(`card releases: invalid contentVersion for ${entry.changeId}`);
        }
        if (entry.releasedAt === null) {
            pendingSeen = true;
        }
        else {
            if (pendingSeen)
                throw new Error('card releases: released entry follows a pending entry');
            if (!UTC_TIMESTAMP.test(entry.releasedAt) || entry.releasedAt < previousReleasedAt) {
                throw new Error(`card releases: invalid or unordered releasedAt for ${entry.changeId}`);
            }
            previousReleasedAt = entry.releasedAt;
        }
        const added = new Set(entry.added);
        const updated = new Set(entry.updated);
        if (added.size !== entry.added.length || updated.size !== entry.updated.length) {
            throw new Error(`card releases: duplicate card id in ${entry.changeId}`);
        }
        if ([...added].some((cardId) => updated.has(cardId))) {
            throw new Error(`card releases: card cannot be added and updated in ${entry.changeId}`);
        }
        for (const cardId of entry.added) {
            if (declaredAdded.has(cardId)) {
                throw new Error(`card releases: card ${cardId} added more than once`);
            }
            declaredAdded.add(cardId);
        }
        for (const cardId of entry.updated) {
            if (!declaredAdded.has(cardId)) {
                throw new Error(`card releases: card ${cardId} updated before it was added`);
            }
        }
        if (entry.releasedAt === null)
            continue;
        for (const cardId of entry.added) {
            result.set(cardId, Object.freeze({
                introducedAt: entry.releasedAt,
                introducedInContentVersion: entry.contentVersion,
                lastUpdatedAt: null,
                lastUpdatedInContentVersion: null,
                lastChangedAt: entry.releasedAt,
            }));
        }
        for (const cardId of entry.updated) {
            const previous = result.get(cardId);
            if (previous === undefined) {
                throw new Error(`card releases: released update for pending card ${cardId}`);
            }
            result.set(cardId, Object.freeze({
                ...previous,
                lastUpdatedAt: entry.releasedAt,
                lastUpdatedInContentVersion: entry.contentVersion,
                lastChangedAt: entry.releasedAt,
            }));
        }
    }
    return result;
}
const CARD_RELEASE_METADATA = buildMetadataIndex(CARD_RELEASES);
const JOURNAL_CARD_IDS = new Set(CARD_RELEASES.flatMap((entry) => [
    ...entry.added,
    ...entry.updated,
]));
const JOURNAL_ADDED_IDS = new Set(CARD_RELEASES.flatMap((entry) => entry.added));
export function getCardReleaseMetadata(cardId) {
    return CARD_RELEASE_METADATA.get(cardId);
}
export function listCardReleaseMetadata() {
    return CARD_RELEASE_METADATA;
}
export function validateCardReleaseCoverage(knownCardIds) {
    const known = new Set(knownCardIds);
    for (const cardId of known) {
        if (!JOURNAL_ADDED_IDS.has(cardId)) {
            throw new Error(`card releases: missing addition for ${cardId}`);
        }
    }
    for (const cardId of JOURNAL_CARD_IDS) {
        if (!known.has(cardId))
            throw new Error(`card releases: unknown card ${cardId}`);
    }
}
//# sourceMappingURL=card-releases.js.map